import logo from "./assets/dd.png";

export default function Header() {
  return (
    <>
      <img src={logo} alt="dd logo" className="logo" />
    </>
  );
}
